import { apiSlice } from "./api/apiSlice";

/**
 * Backend contract for the Meta leads reconciliation view.
 *
 * GET facebook/leads
 *   Query params: from, to, formId, status, assignedTo, search
 *   Returns every lead form submission Meta holds for the date range, each
 *   tagged with what the CRM knows about it:
 *     {
 *       success: true,
 *       stats: { total, inCrm, notImported, failed },
 *       data: [{
 *         leadgenId, name, phone, formId, formName, projectName,
 *         submittedAt,                       // ISO string, Meta's created_time
 *         status,                            // "inCrm" | "notImported" | "failed"
 *         assignedTo: { id, name } | null,
 *         leadID: Number | null,             // set once it exists in the CRM
 *         error: String | null               // why it failed, shown on the row
 *       }]
 *     }
 *
 * POST facebook/leads/import  { leads: [{ leadgenId, formId }] }
 *   Imports the given submissions. Each entry carries its formId because that
 *   is what decides the lead's project, and Meta does not reliably return it
 *   on the lead itself. Safe to call on leads already in the CRM — the
 *   duplicate check skips them. Returns { summary, results }.
 */
const socialMediaSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllActiveForms: builder.query({
      query: () => ({
        url: `facebook/leadgen_forms`,
      }),
      transformResponse: (response, meta, arg) => response.data,
      //   providesTags: ["Social"],
    }),

    getMetaLeads: builder.query({
      query: (filters = {}) => {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== "" && value !== null && value !== undefined) {
            params.append(key, value);
          }
        });
        const queryString = params.toString();
        return { url: `facebook/leads${queryString ? `?${queryString}` : ""}` };
      },
      transformResponse: (response) => ({
        rows: response?.data || [],
        stats: response?.stats || null,
      }),
      providesTags: ["SocialLeads"],
    }),

    importMetaLeads: builder.mutation({
      query: (leads) => ({
        url: `facebook/leads/import`,
        method: "POST",
        body: { leads },
      }),
      invalidatesTags: ["SocialLeads", "Leads"],
    }),
  }),
});

export const {
  useGetAllActiveFormsQuery,
  useGetMetaLeadsQuery,
  useImportMetaLeadsMutation,
} = socialMediaSlice;
